import { ClientLogger } from '../lib/logger/client.js';

export const clientLogger = new ClientLogger();
